/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Table_Header_Sub_ProcessorInputs */

const en_privacy_table_header_sub_processor = /** @type {(inputs: Privacy_Table_Header_Sub_ProcessorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sub-Processor`)
};

const de_privacy_table_header_sub_processor = /** @type {(inputs: Privacy_Table_Header_Sub_ProcessorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auftragsverarbeiter`)
};

const fr_privacy_table_header_sub_processor = /** @type {(inputs: Privacy_Table_Header_Sub_ProcessorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-traitant`)
};

const es_privacy_table_header_sub_processor = /** @type {(inputs: Privacy_Table_Header_Sub_ProcessorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subencargado`)
};

const it_privacy_table_header_sub_processor = /** @type {(inputs: Privacy_Table_Header_Sub_ProcessorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sub-responsabile`)
};

const nl_privacy_table_header_sub_processor = /** @type {(inputs: Privacy_Table_Header_Sub_ProcessorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subverwerker`)
};

const pl_privacy_table_header_sub_processor = /** @type {(inputs: Privacy_Table_Header_Sub_ProcessorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podwykonawca`)
};

const fi_privacy_table_header_sub_processor = /** @type {(inputs: Privacy_Table_Header_Sub_ProcessorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alikäsittelijä`)
};

const da_privacy_table_header_sub_processor = /** @type {(inputs: Privacy_Table_Header_Sub_ProcessorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underdatabehandler`)
};

const sv_privacy_table_header_sub_processor = /** @type {(inputs: Privacy_Table_Header_Sub_ProcessorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underbiträde`)
};

/**
* | output |
* | --- |
* | "Sub-Processor" |
*
* @param {Privacy_Table_Header_Sub_ProcessorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_table_header_sub_processor = /** @type {((inputs?: Privacy_Table_Header_Sub_ProcessorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Table_Header_Sub_ProcessorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_table_header_sub_processor(inputs)
	if (locale === "fr") return fr_privacy_table_header_sub_processor(inputs)
	if (locale === "es") return es_privacy_table_header_sub_processor(inputs)
	if (locale === "it") return it_privacy_table_header_sub_processor(inputs)
	if (locale === "nl") return nl_privacy_table_header_sub_processor(inputs)
	if (locale === "pl") return pl_privacy_table_header_sub_processor(inputs)
	if (locale === "fi") return fi_privacy_table_header_sub_processor(inputs)
	if (locale === "da") return da_privacy_table_header_sub_processor(inputs)
	if (locale === "sv") return sv_privacy_table_header_sub_processor(inputs)
	return en_privacy_table_header_sub_processor(inputs)
});